import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export interface PendingInvite {
  email: string;
  last_login: string | null;
}

export interface PendingInvitesResponse {
  success: boolean;
  message: string;
  response: any;
  data: PendingInvite[];
}

export const pendingInvitesApi = createApi({
  reducerPath: "pendingInvitesApi",
  baseQuery: fetchBaseQuery({
    baseUrl: "https://cp-employees.confiebeta.com",
  }),
  endpoints: (builder) => ({
    getPendingInvites: builder.query<PendingInvite[], void>({
      query: () => ({
        url: "/employees/get_pending_send_invitations",
        method: "GET",
      }),
      transformResponse: (response: PendingInvitesResponse) => response.data,
    }),
  }),
});

export const { useGetPendingInvitesQuery, useLazyGetPendingInvitesQuery } = pendingInvitesApi;
